import { styled } from "@mui/system";
import { Button } from "@mui/material";

export const TrackNSwitchAccountBtn = styled(Button, {
  shouldForwardProp: prop => prop !== "buttonColor"
})(({ theme, buttonColor = "#000" }) => ({
  boxSizing: "content-box",
  borderRadius: "6.25rem",
  border: `1px solid ${buttonColor}`,
  fontSize: "0.75rem",
  textAlign: "center",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "1rem",
  color: buttonColor,
  textTransform: "none",
  letterSpacing: "0rem",
  padding: "0.5rem 0.75rem",
  [theme.breakpoints.up("sm")]: {
    textAlign: "unset",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    padding: "0.75rem 1.25rem"
  }
}));
